import type { IUserRepository } from "@src/domain/users/repository/user.repository.interface";
import type { UserDTO } from "../dto/user.dto";
import { UserDtoMapper } from "../mappers/user-dto.mapper";

/**
 * Use Case: Ban User
 * Bans a user from accessing the system (Admin only)
 */
export class BanUserUseCase {
    constructor(private readonly userRepository: IUserRepository) { }

    /**
     * Execute the use case
     * @param userId - User ID
     * @returns Promise<UserDTO> - Updated user DTO with banned status
     * @throws Error if userId is invalid
     */
    async execute(userId: string): Promise<UserDTO> {
        if (!userId || !userId.trim()) {
            throw new Error('User ID is required');
        }

        const user = await this.userRepository.ban(userId);
        return UserDtoMapper.toDTO(user);
    }
}
